import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const rubyType = 'national_security'
const storeType = 'nationalSecurities'

export const PENationalSecuritiesCardActions = {
  initPeNationalSecuritiesCard: ({ commit }, index) => {
    commit('setPeNationalSecuritiesCardLock', { index, lock: true })
  },
  peFetchNationalSecuritiesCards: async ({ commit, getters }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants`, { params: { type: rubyType } }).
      then(({ data }) => {
        const assistantCards = data?.asylum_assistant
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: assistantCards || [],
        })
      })
  },
  peNationalSecuritiesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post(`/parties/${party.id}/asylum_assistants`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            putative_incident: section.putative_incident,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeNationalSecuritiesCardLock', { index: 'new', lock: true })
        commit('setPeNationalSecuritiesCardLock', { index: data.id, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peNationalSecuritiesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants/${section.id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        commit('setPeNationalSecuritiesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistant', {
          assistant: storeType,
          value: data,
        })
      }).
      catch(handleError)
  },
  peNationalSecuritiesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/parties/${party.id}/asylum_assistants/${id}`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            putative_incident: section.putative_incident,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeNationalSecuritiesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peNationalSecuritiesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/parties/${party.id}/asylum_assistants/${id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeNationalSecuritiesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peNationalSecuritiesCardAddSection: ({ commit }) => {
    commit('setPeNationalSecuritiesCardLock', { index: 'new', lock: false })
    commit('addPeNationalSecuritiesCardSection', {
      id: null,
      putative_incident: '',
      narrative: '',
    })
  },
  peNationalSecuritiesCardDownloadPDF: async ({ getters }, { legalCaseId }) => {
    const party = getters.peParty

    return await axiosRequest.
      post(`/parties/${party.id}/asylum_assistant_download`, { asylum_assistant: { legal_case_id: legalCaseId } }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const PENationalSecuritiesCardMutations = {
  setPeNationalSecuritiesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.NationalSecuritiesCard) {
      Vue.set(state.partyEdit.partySections, 'NationalSecuritiesCard', {})
    }
    Vue.set(state.partyEdit.partySections.NationalSecuritiesCard, index, lock)
  },
  addPeNationalSecuritiesCardSection: (state, section) => state.partyEdit.asylumAssystant[storeType].push(section),
  peNationalSecuritiesCardCreateUndo: state => {
    state.partyEdit.asylumAssystant[storeType].pop()
    Vue.set(state.partyEdit.partySections.NationalSecuritiesCard, 'new', true)
  },
}

export const PENationalSecuritiesCardGetters = {
  peNationalSecuritiesCardLock: state => index => state.partyEdit.partySections.NationalSecuritiesCard[index],
  peNationalSecuritiesCardHasNewSection: state => !!state.
    partyEdit.
    asylumAssystant[storeType]?.
    find(nationalSecurity => nationalSecurity.id === null),
}
